<template>
    <div v-if="cargando">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3> 
            </div>
        </div>
    </div>
    <div v-else>
    <br>
    <b-row>
        <b-col md="2">
            <b-form-group horizontal label="Orden" class="mb-0">
                <b-input-group>
                <b-form-select v-model="orden" slot="append" @input="listCreditNote">
                    <option :value="'asc'">Mas Antiguo</option>
                    <option :value="'desc'">Mas Reciente</option>
                </b-form-select>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col cols="1" sm="2"	md="2"	lg="2"	xl="3">
              <b-form inline>
                  Desde: <b-input type="date" v-model="f1"/>
                  Hasta: <b-input type="date" v-model="f2"/>
              </b-form>
         </b-col>
        <b-col>
          <b-button @click="listCreditNote" variant="success">Buscar</b-button>
        </b-col>
        <b-col md="2">
            <div class="col-md-12 text-center">
                <b-button variant="secondary" @click="listCreditNote"><i class="fa fa-sync-alt"></i> </b-button>
            </div>
        </b-col>
        <b-col md="2">
            <b-form-group horizontal label="Mostrar" class="mb-0">
                <b-input-group>
                    <b-form-select v-model="limite" slot="append" @input="listCreditNote">
                    <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </b-form-select>                            
                </b-input-group>                        
            </b-form-group>                    
        </b-col>
    </b-row>
    <br>

    <b-table
        responsive 
        :small="small"
        :striped="striped"
        :outlined="outlined"
        :items="creditnotes"
        :fields="creditnotes_fields"
        :current-page="pactual"
        :per-page="limite"                   
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"  
        >
        <template slot="estado" slot-scope="row">
            <template v-if="row.item.emitido==1 && row.item.baja==1">
                <div><span class="badge badge-dark">Baja <i class="fa fa-ban"></i></span></div>
            </template>
            <template v-else-if="row.item.emitido==3 && row.item.baja==0">
                <div><span class="badge badge-info">Baja pendiente <i class="fa fa-ban"></i></span></div>
            </template>
            <template v-else>
                <div v-if="row.item.emitido==1"><span class="badge badge-success">Emitido <i class="fa fa-check"></i></span></div>
                <div v-else-if="row.item.emitido==0"><span class="badge badge-warning">Procesando <i class="fa fa-spin fa-spinner"></i></span></div>
                <div v-else-if="row.item.emitido==2"><span class="badge badge-danger">Rechazado <i class="fa fa-times"></i></span></div>
            </template>
        </template>
        <template slot="receptor" slot-scope="row">
            <template v-if="row.item.receiver">
                {{row.item.idReceptor}} - {{row.item.receiver.razonSocial}}
            </template>
            <template v-else>
                {{ row.item.idReceptor }}
            </template>            
        </template>
        <template slot="emision" slot-scope="row">
            <template v-if="row.item.fechaEmision !== '0000-00-00 00:00:00'">
                {{ row.item.fechaEmision | moment('D/M/Y hh:mm:ss A') }} 
            </template>
            <template v-else>
                -
            </template>            
        </template>
        <template slot="moneda" slot-scope="row">
            <template v-if="row.item.tipoMoneda=='PEN'">S/</template>
            <template v-else-if="row.item.tipoMoneda=='USD'">$</template>
            <template v-else>{{ row.item.tipoMoneda }}</template>                     
            {{row.item.importeTotal}}
        </template>
        <template slot="acciones" slot-scope="row">
            <template v-if="row.item.emitido!=2 && row.item.baja!=1">  
                <b-button-group>
                    <button v-show="!row.item.loading" type="button" class="btn" size="sm" @click="mostrarDetalles(row, row.index)" title="Mas opciones">
                        <template v-if="!row.item.mostrardetalles">
                            <i class="fa fa-plus"></i>
                        </template>
                        <template v-else>
                            <i class="fa fa-minus"></i>
                        </template>
                    </button>
                    <b-button size="sm" v-show="row.item.loading" variant="ligth"><i class="fa fa-spin fa-spinner"></i></b-button>
                    <b-button v-b-tooltip.hover v-b-modal.modalprevnc @click="viewPdf(row.item)"><i title="Vista Previa" class="fa fa-tv"></i></b-button>
                    <b-button @click="downloadPdf(row.item)" v-b-tooltip.hover><i title="Descargar PDF" class="fa fa-file-pdf"></i></b-button>                        
                    <b-button @click="setNote(row.item)" v-b-modal.modalsendnc v-b-tooltip.hover><i title="Enviar por Mail" class="fa fa-envelope"></i></b-button>                      
                    <b-button v-if="row.item.emitido==0" class="disabled" :disabled="true"><i title="Descargar CDR" class="fa fa-file-archive"></i></b-button>
                    <b-button v-else @click="downloadCdr(row.item)"><i title="Descargar CDR" class="fa fa-file-archive"></i></b-button>
                    <b-button v-if="row.item.emitido==0" class="disabled" :disabled="true" v-b-tooltip.hover><i title="Descargar XML" class="fa fa-file-code"></i></b-button>
                    <b-button v-else @click="downloadXml(row.item)" v-b-tooltip.hover><i title="Descargar XML" class="fa fa-file-code"></i></b-button>
                    <b-button v-if="row.item.emitido==0 || row.item.baja==1" v-show="row.item.emitido!=3 || row.item.baja==1" :disabled="true" v-b-tooltip.hover class="disabled btn btn-danger"><i title="Baja de Factura" class="fa fa-trash-alt text-white"></i></b-button>
                    <b-button v-else v-show="row.item.emitido!=3 || row.item.baja==1" @click="preBaja(row.item)" v-b-tooltip.hover class="btn btn-danger"><i title="Baja de Factura" class="fa fa-trash-alt text-white"></i></b-button>                     
                </b-button-group>
            </template>
            <template v-else>
                <b-button-group>
                    <b-button @click="downloadCdr(row.item)"><i title="Descargar CDR" class="fa fa-file-archive"></i></b-button>
                    <b-button v-if="row.item.emitido==2" @click="estadoEmision(row.item)" v-b-modal.motivorechazo2 v-b-tooltip.hover variant="primary"><i title="Estado de la emision" class="fa fa-eye text-white"></i></b-button>
                </b-button-group>
            </template>
        </template>
        <template slot="row-details" slot-scope="row">
                <b-card class="tamanioletra">
                    <b-table striped hover :items="row.item.lista" :fields="listaitems_fields" :busy="row.item.loading">
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Cargando...</strong>
                        </div>
                        <template slot="index" slot-scope="row">
                            {{ row.index+1 }}
                        </template>
                        <template slot="cantidad" slot-scope="row">
                            <div class="text-right">
                                {{ Number.parseFloat(row.item.cantidad).toFixed(2) }}
                            </div>
                        </template>
                        <template slot="precioVentaUnitario" slot-scope="row">
                            <div class="text-right">
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template v-if="row.item.precioVentaUnitario">
                                    {{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}
                                </template>
                            </div>
                        </template>
                        <template slot="descuento" slot-scope="row">
                            <div class="text-right">
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template v-if="row.item.descuento">
                                    {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                                </template>
                                <template v-else>
                                    0.00
                                </template>
                            </div>
                        </template>     
                        <template slot="valorVenta" slot-scope="row">
                            <div class="text-right">
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template v-if="row.item.valorVenta">
                                    {{ Number.parseFloat(row.item.valorVenta*($store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2) }}
                                </template>
                            </div>
                        </template>
                    </b-table>
                </b-card>
            </template>  
    </b-table>
    <b-modal v-model="modalsendnc"  id="modalsendnc" title="Enviar por Correo">
        <div role="group">
        <label for="inputLive">Correos:</label>
        <b-form-input v-model="recipients" type="email" @keyup.enter="sendMail(note)" class="input-requierido"></b-form-input>
        <p class="input-requerido">Ingresa un correo ó varios separados por comas (,)</p>
        </div>
            <div slot="modal-footer" class="w-100">
            <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="sendMail(note)">
            Enviar
            </b-btn>
            <b-btn v-else size="sm" class="float-right" variant="secondary">
            <i class="fa fa-spin fa-spinner"></i> Enviando... 
            </b-btn>
        </div>
    </b-modal>
    <b-modal id="motivorechazo2" title="Motivo del Rechazo" v-model="motivoRechazo">
        <div role="group">
            <div v-if="spinoff">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h6>{{ descripcionRechazo }}</h6>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100">
            <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="motivoRechazo=!motivoRechazo">
                Ok
            </b-btn>
        </div>
    </b-modal>          
    <b-modal id="modalprevnc" size="lg" title="Vista Previa" cancel-title="Cerrar">
        <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
        <template v-else>
            <template v-if="pdfobject !==''">
            <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
            </template>
        </template>                
    </b-modal>
    <div class="row">
        <div class="col-md-9">
            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
        </div>
        <div class="col-md-3">
            <b-pagination size="sm" :total-rows="total" v-model="currentPage" :per-page="limite" @input="listCreditNote"></b-pagination>
        </div>
    </div>
    <b-modal id="modalpreproccess" v-model="modal">
        <template slot="modal-title">
            <i class="fa fa-exclamation-triangle text-danger"></i> Dar de baja a una Nota de Credito
        </template>
        <p class="my-4 h4"><b>{{this.$store.getters.userData.username}}</b>, realmente desea dar de baja a la siguiente Nota de Credito?</p>
        <b-list-group>
            <template>
                <template>
                    <b-list-group-item>{{facturaItemBaja.serie + '-' + facturaItemBaja.numero + ' | ' + facturaItemBaja.idReceptor + '-' + facturaItemBaja.razonSocial}}</b-list-group-item>
                </template>
            </template>
        </b-list-group>
        <br>
        <b-alert v-if="!loading2" variant="danger" show>El siguiente procedimiento no se puede deshacer.</b-alert>
        <b-alert v-else variant="danger" show>Estamos dando de baja los documentos indicados.</b-alert>
        <template slot="modal-footer">
            <template v-if="!loading2">
            <b-button variant="secondary" @click="modal=false">No</b-button>
            <b-button variant="danger" @click="sendBaja"><i class="fa fa-cog"></i> Procesar</b-button>
            </template>
            <b-button v-else disabled variant="danger"><i class="fa fa-spin fa-cog"></i> Procesando</b-button>
        </template>
    </b-modal>
    <vue-snotify></vue-snotify>
</div>
</template>

<script>
const config = {
       headers: {
            'Content-type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin':'*',
            'Access-Control-Allow-Methods': 'POST',
            'Access-Control-Allow-Headers':'*',
            'cache-control': 'no-cache'
          }
}
import { tiposNotaCreditoF } from '@/shared/utils'
import axios from 'axios'
import download from 'downloadjs'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import { EspecificacionIgvTipo1 } from '@/shared/utils'
import { EspecificacionIgvTipo2 } from '@/shared/utils'
export default {
    name: 'NotaCreditoFacturaConsulta',
    components: {
        Datepicker
    },
    props: ['reload'],
    data: () => {
        return {
            facturaItemBaja: {
                serie: '',
                numero: '',
                idReceptor: '',
                razonSocial: ''
            },
            facturaBaja: {
                descripcion: 'DE BAJA',
                serie: '',
                numero: '',
                tipoComprobante: '01'
            },
            itembaja: [],
            loading2: false,
            modal: false,
            motivoRechazo: false,
            spinoff: false,
            descripcionRechazo: '',
            reloadLocal: false,
            sortDesc: false,
            sortDirection: 'asc',
            sortBy: null,
            currentPage: 1,
            striped: true,
            small: true,
            outlined: true,
            modalInfo: { holi1: 'holi', holi2: 'holi2' },
            itemAlterado: false,
            montoActual: '',
            montoDescuento: '',
            fieldsNC: ['cantidad', 'descripcion', 'valorUnitario', 'valorVenta', 'actions', 'acciones'],
            invoice: [],
            listaNotaCredito: [],
            listaNotaCreditoAfectada: [],
            descuentoItemSiguiente: false,
            generalesNC: false,
            especificacionIgv1: EspecificacionIgvTipo1,
            especificacionIgv2: EspecificacionIgvTipo2,
            modalsendnc: false,
            especificacionIgv: '01',
            afectacionIgv: '01',
            monto: '',
            igv: '',
            currentdate: '',
            es: es,
            femision: '',
            hemision: '',
            emisioncreditnote: false,
            previanotacredito: false,
            previacorreo: false,
            sendcorreo: false,
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            cargando: false,
            pactual: 1,
            limite: 10,
            orden: 'desc',
            recipients: '',     
            listaafectacion: [
                {
                    id: '02',
                    descripcion: 'Inafecto'
                },
                {
                    id: '01',
                    descripcion: 'Gravado'
                },
                {
                    id: '03',
                    descripcion: 'Exonerado'
                },
                {
                    id: '04',
                    descripcion: 'Exportación'
                }
            ],
            Especificacion: [],
            especificacion:{
                codigo: '10',
                descripcion: 'Operacion onerosa',
                codigoTributo: '1000'
            },
            creditnotes: [],
            creditnotesinvoice: [],
            creditnotes_fields: [
                {key: 'serie', label: 'Serie', sortable: true},
                {key: 'numero', label: 'Numero', sortable: true},
                {key: 'emision', label: 'Emision', sortable: true},
                {key: 'receptor', label: 'Receptor', sortable: true},
                {key: 'moneda', label: 'Importe Total', sortable: true},
                {key: 'estado', label: 'Estado', sortable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            listaitems_fields: [
                {key: 'index'},
                {key: 'codigoProducto', label: 'Codigo', sorteable: true},
                {key: 'unidadMedidaCantidad', label: 'Unidad', sorteable: true},
                {key: 'descripcion', label: 'Descripción', sorteable: true},
                {key: 'cantidad', label: 'Cantidad', sorteable: true},
                {key: 'precioVentaUnitario', label: 'Precio Unit', sorteable: true},
                {key: 'descuento', label: 'Descuento', sorteable: true},
                {key: 'valorVenta', label: 'Precio Total', sorteable: true},
            ],
            note: {},
            CreditNote: {
                token: '',
                serie: '',
                horaEmision: '',
                tipoNotaCredito: '',
                montoTotalImpuestos: '',
                totalVentaGravada: '',
                sumatoriaIgv: '',
                importeTotal: '',
                descripcion: '',
                tipoMoneda: '',
                serieAfectado: '',
                numeroAfectado: '',
                tipoComprobanteAfectado: '01',
                adicional: {
                    fechaVencimiento: "2018-12-25",
                    codigoSunatEstablecimiento: "0001"
                },
                items: [],
                receptor: {
                    tipo: '6',
                    nro: ''
                }
            },
            items: [],
            tiposNotaCredito: tiposNotaCreditoF,
            serieAfectada: '',
            checkSerieAfectada: false,
            responseSerieAfectado: '',
            numeroAfectado: '',
            checkNumeroAfectado: false,
            responseNumeroAfectado: '',
            serieNC: '',
            checkSerieNC: false,
            responseSerieNC: '',
            descripcionNC: '',
            checkDescripcionNC: false,
            responseDescripcionNC: '',
            cargandoemisionCaso1: false,
            cargandoemisionCaso5: false,
            pdfobject: '',
            cargandopdf: false,
            cargandopdf2: false,
            checkserie: false,
            checknumero: false,
            diasnopermitidos: {
            ranges: []
            },
            tiponotacredito: '01',
            f1:'',
            f2:'',
        }
    },
    mounted () {
        this.initIgv(),
        this.initDates(),
        this.listCreditNote(),
        this.initNCDefault()
    },
    watch: {
        tiponotacredito: function () {
            if(this.tiponotacredito == '01' || this.tiponotacredito == '05'){
                this.generalesNC = true
            }else{
                this.generalesNC = false
            }
        },
        reload: function () {
           this.reloadLocal = this.reload
            if(this.reloadLocal == true){
                this.listCreditNote()
            } 
        }
    },
    computed: {
        state () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serieNC.length == 0){

            } else if (!expreg.test(this.serieNC)) {
                return false
            } else if(this.serieNC.length == 3 ){
                return true
            }
        },
        invalidFeedback () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serieNC.length == 0) {
                return 'Ingresa una Serie'
            } else {
                return 'Minimo 3 caracteres'
            }
        },
        validFeedback () {
            return this.state === true ? 'Perfecto' : ''
        },
        stateSerieAfectada () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serieAfectada.length == 0){

            } else if (!expreg.test(this.serieAfectada)) {
                return false
            } else if(this.serieAfectada.length == 3 ){
                return true
            }
        },
        invalidFeedbackSerieAfectada () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serieAfectada.length == 0) {
                return 'Ingresa una Serie'
            } else {
                return 'Minimo 3 caracteres'
            }
        },
        validFeedbackSerieAfectada () {
            return this.stateSerieAfectada === true ? 'Perfecto' : ''
        }
    },
    methods: {
        mostrarDetalles: function (row, index) {
            if(row.detailsShowing){
                row.toggleDetails()
                this.creditnotes[index].mostrardetalles = false
            }else{
                this.creditnotes[index].mostrardetalles = true
                this.creditnotes[index].loading = true
                if(this.creditnotes[index].lista.length == 0){
                    setTimeout(() => 
                        this.detallesDocumento(row, index)
                    , 10);  
                }else{
                    this.creditnotes[index].loading = false
                    row.toggleDetails()
                }  
            }
        },
        detallesDocumento: function (row, index) {
            axios
            .post(process.env.VUE_APP_API_URL + 'notacredito/items',{
                token: this.$store.getters.userToken,
                idcredit: row.item.idNotaCredito
            })
            .then(response => (
                this.parseDetallesDocumento(response.data.response, row, index)
            ))
            .catch(error => (  
                this.creditnotes[index].mostrardetalles = false
            )) 
        },
        parseDetallesDocumento: function (value, row, index) {
            this.creditnotes[index].lista = []
            for (let i=0; i<value.length; i++){
                value[i].moneda = row.item.tipoMoneda
                this.creditnotes[index].lista.push(value[i])
            }
            this.creditnotes[index].loading = false
            // this.creditnotes[index].mostrardetalles = false
            if(value.length > 0){
                row.toggleDetails()
            }
        },
        preBaja: function (value) {
            this.modal = true,
            this.itembaja = [],
            this.facturaItemBaja.serie = value.serie,
            this.facturaItemBaja.numero = value.numero,
            this.facturaItemBaja.idReceptor = value.idReceptor,
            this.facturaItemBaja.razonSocial = value.receiver.razonSocial,
            this.facturaBaja.descripcion = 'DE BAJA',
            this.facturaBaja.serie = value.serie,
            this.facturaBaja.numero = value.numero,
            this.facturaBaja.tipoComprobante = '07',
            this.itembaja.push(this.facturaBaja),
            this.date = value.fechaEmision
        },
        sendBaja: function () {
            this.loading2 = true
            axios
            .post(process.env.VUE_APP_API_URL + 'comunicacionbaja/emitir', {
                token: this.$store.getters.userToken,
                fechaEmisionDocs: this.$moment(this.date).format('YYYY-MM-DD'),
                items: this.itembaja
            })
            .then(response => ( 
                this.loading2 = false,               
                this.modal = false,
                this.listCreditNote(),
                this.initValuesBaja(),
                this.$snotify.success(response.data.msg, 'Éxito')
            ))
            .catch((error) => (
                this.loading2 = false,
                this.modal = false,
                this.initValuesBaja(),
                this.$snotify.error(error.response.data.response.description, 'Error')
            )) 
        },
        initValuesBaja: function() {
            this.facturaItemBaja.serie = '',
            this.facturaItemBaja.numero = '',
            this.facturaItemBaja.idReceptor = '',
            this.facturaItemBaja.razonSocial = '',
            this.facturaBaja.descripcion = 'DE BAJA',
            this.facturaBaja.serie = '',
            this.facturaBaja.numero = '',
            this.facturaBaja.tipoComprobante = '01',
            this.itembaja = []
        },
        changeItemCaso5: function () {
            this.itemAlterado = true
        },
        sendItemCaso5: function (value) {
            this.montoActual = value.valorUnitario
        },
        cerrarNC: function () {
            this.emisioncreditnote = false
        },
        initNCDefault: function () {
            this.generalesNC = true
        },
        initIgv: function () {
            if(this.especificacionIgv === '01'){
                this.Especificacion = this.especificacionIgv1
            }
            else if(this.especificacionIgv === '02'){
                this.Especificacion = this.especificacionIgv2
            }
        },
        initDates: function () {
            let r1 = {
                from: this.$moment().subtract(50000,'years'),
                to: this.$moment().subtract(6,'days')
            }
            let r2 = {
                from: this.$moment().add(0,'days'),
                to: this.$moment().add(60000,'years')
            }
            this.diasnopermitidos.ranges.push(r1)
            this.diasnopermitidos.ranges.push(r2)
            this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss')
        },
        validateCreditNote: function () {
            if(this.serieNC != '' && this.descripcionNC != '' && this.tiponotacredito != '0'){
                return true
            }
            else{
                return false
            }
        },
        listCreditNote: function () {
            let dia1;
            let dia2;
            if(this.f1 === "" && this.f2 ===""){
                dia1 =  ""
                dia2 = ""
            }else{
                dia1 = this.$moment(this.f1).format('YYYY-MM-DD HH:mm:ss')
                dia2 = this.$moment(this.f2).format('YYYY-MM-DD 23:59:59')          
            }
            this.creditnotes = [],
            this.cargando = true
            axios
            .post(process.env.VUE_APP_API_URL + 'notacredito/factura', {
                token: this.$store.getters.userToken,
                f1:dia1,
                f2:dia2,
                page: this.currentPage,
                limit: this.limite,
                order: this.orden
            })
            .then(response => (
                this.creditnotes = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargando = false,
                this.creditnotes.forEach(function(element){
                    element.loading = false
                })
                ))
            .catch(error => {})
        },
        searchInvoice: function () {
            this.cargandoemisionCaso1 = true
            this.cargandoemisionCaso5 = true
            this.emisioncreditnote = true
            axios
           .post(process.env.VUE_APP_API_URL + 'facturas/obtener/detalles',{
               token: this.$store.getters.userToken,
               p: 'F' + this.serieAfectada + '-' + this.numeroAfectado,
               filtro: 'name'
           }, config)
           .then(response => (
                this.invoice = response.data,
                this.listaNotaCredito = response.data.response.details,
                this.listaNotaCreditoAfectada = response.data.response.details,
                this.redirectCreditNoteTipo()
           ))
           .catch(function (error){
               this.emisioncreditnote = false
           })
        },
        redirectCreditNoteTipo: function () {
            if(this.tiponotacredito == '01'){
                this.emisioncreditnote = false,
                this.sendNoteCredit()
            }else if(this.tiponotacredito == '05'){
                this.cargandoemisionCaso5 = false,
                this.generalesNC = false
                this.descuentoItemSiguiente = true
            }
        },
        setNote: function (data) {
            this.note = data
        },
        sendMail: function (data) {
            this.modalsendnc = true
            this.previacorreo = true
            this.sendcorreo = true
            axios
            .post(process.env.VUE_APP_API_URL + 'notacredito/mail', {
                token: this.$store.getters.userToken,
                id: data.idNotaCredito,
                mail: this.recipients 
            })
            .then(response => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.modalsendnc = false,
                this.$snotify.success(response.data.msg, 'Exito')            
                ))
            .catch(error => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.modalsendnc = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        viewPdf: function (data) {
            this.pdfobject = ''
            this.cargandopdf2 = true
            axios
           .post(process.env.VUE_APP_API_URL + 'notacredito/pdf',{
               token: this.$store.getters.userToken,
               id: data.idNotaCredito
           }, config)
           .then(response => (
               this.pdfobject = response.data.base64,
               this.cargandopdf2 = false
           ))
           .catch(function (error){

           })
        },
        downloadPdf: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = data.serie + '-' + data.numero + '.pdf'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandopdf = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'notacredito/pdf',{
               token: this.$store.getters.userToken,
               id: data.idNotaCredito
           })
           .then(response => (
               file = 'data:application/pdf;base64,'+ response.data.base64,
               this.cargandopdf = false,               
               download(file, name,'application/pdf'),
               this.$swal.close()
           ))
            .catch(error => (
                this.$swal.close(),
                this.$snotify.error(error.response.data.response, 'Error'),
                this.cargandopdf = false
            ))         
        },
        downloadCdr: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = 'CDR-' + data.serie + '-' + data.numero + '.zip'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandocdr = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'notacredito/constancia',{
               token: this.$store.getters.userToken,
               id: data.idNotaCredito
           })
           .then(response => (
               file = 'data:application/zip;base64,'+ response.data.msg.xml,
               this.cargandocdr = false,               
               download(file, name,'application/zip'),
               this.$swal.close()
           ))
           .catch(function (error){
               
           })    
        },
        downloadXml: function (data){
            let xml = ''
            let file = ''
            let name = data.serie + '-' + data.numero + '.zip'
            let tag = document.createElement('i')
            this.cargandopdf = true
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            this.$swal({
            title: 'Obteniendo XML',
            content: tag,
            icon: 'info',
            buttons: false,
            dangerMode: false
            })
            axios
            .post(process.env.VUE_APP_API_URL + 'notacredito/xml', {
                token: this.$store.getters.userToken,
                id: data.idNotaCredito
            })
            .then(response => (
                xml = response.data.response.xml,
                file = 'data:application/zip;base64,'+ xml,
                this.downloadxml(file, name, xml),
                this.$swal.close()
            ))
            .catch(error => (
                this.$snotify.error('Error al descargar el archivo', 'Error')
            ))
        },
        estadoEmision: function (value) {
            this.spinoff = true
            axios
            .post(process.env.VUE_APP_API_URL + 'documento/motivorechazo', {
                token: this.$store.getters.userToken,
                serie: value.serie,
                numero: value.numero,
                tipo: '01'
            })
            .then(response => ( 
                this.descripcionRechazo = response.data.msg.descripcion,
                this.spinoff = false
            ))
            .catch(error => (
                this.$snotify.error(error.response.data, 'Error'),
                this.motivoRechazo = false,
                this.spinoff = false
            )) 
        },
        downloadxml: function (file, name, xml) {
            if(xml != null){
                download(file, name,'application/zip')
            }else{
                this.$snotify.error('El documento aun no tiene constancia porque esta en proceso!', 'Error')
            }   
        },
        sendNoteCredit: function () {     
            let item = {}
            let nroitems = this.invoice.response.details.length
            for (let i = 0; i < nroitems; i++){
                item.unidadMedidaCantidad = this.invoice.response.details[i].unidadMedidaCantidad,
                item.cantidad = this.invoice.response.details[i].cantidad,
                item.valorVenta = this.invoice.response.details[i].valorVenta,
                item.precioVentaUnitario = this.invoice.response.details[i].precioVentaUnitario,
                item.tipoPrecioVentaUnitario = this.invoice.response.details[i].tipoPrecioVentaUnitario,
                item.montoTotalImpuestosItem = this.invoice.response.details[i].montoTotalImpuestosItem,
                item.baseAfectacionIgv = this.invoice.response.details[i].baseAfectacionIgv,
                item.montoAfectacionIgv = this.invoice.response.details[i].montoAfectacionIgv,
                item.porcentajeImpuesto = this.invoice.response.details[i].porcentajeImpuesto,
                item.tipoAfectacionIgv = this.invoice.response.details[i].tipoAfectacionIgv,
                item.codigoTributo = this.invoice.response.details[i].codigoTributo,
                item.descripcion = this.invoice.response.details[i].descripcion,
                item.valorUnitario = this.invoice.response.details[i].valorUnitario,
                item.codigoProducto = this.invoice.response.details[i].codigoProducto,
                item.codigoProductoSunat = this.invoice.response.details[i].codigoProductoSunat,
                item.descuento = this.invoice.response.details[i].descuento,
                item.porcentajeDescuento = this.invoice.response.details[i].porcentajeDescuento,
                this.items.push(item) 
            }
            this.CreditNote.token = this.$store.getters.userToken
            if(this.femision != ''){
                // this.CreditNote.fechaEmision = this.$moment(this.femision).format('YYYY-MM-DD HH:mm:ss')
                this.CreditNote.fechaEmision = this.femision
            }    
            this.CreditNote.serie = 'F' + this.serieNC,            
            this.CreditNote.tipoNotaCredito = this.tiponotacredito,
            this.CreditNote.montoTotalImpuestos = this.invoice.response.montoTotalImpuestos,
            this.CreditNote.totalVentaGravada = this.invoice.response.totalVentaGravada,
            this.CreditNote.sumatoriaIgv = this.invoice.response.sumatoriaIgv,
            this.CreditNote.importeTotal = this.invoice.response.importeTotal,
            this.CreditNote.descripcion = this.descripcionNC,
            this.CreditNote.tipoMoneda = this.invoice.response.tipoMoneda,
            this.CreditNote.serieAfectado = 'F' + this.serieAfectada,
            this.CreditNote.numeroAfectado = this.numeroAfectado,
            this.CreditNote.receptor.nro = this.invoice.response.idReceptor,
            this.CreditNote.items = this.items
            
            axios
           .post(process.env.VUE_APP_API_URL + 'notacredito/emitir', this.CreditNote, config)
           .then(response => (
               this.cargandoemisionCaso1 = false,
               this.emisioncreditnote = false,
               this.CreditNote = [],
               this.serieNC = '',
               this.serieAfectada = '',
               this.numeroAfectado = '',
               this.descripcionNC = '',
               this.listCreditNote(),
               this.$snotify.success(response.data.msg, 'Exito')
           ))
           .catch(error => (
                this.$snotify.error(error.response.data.response.message, 'Error'),
                this.cargandoemisionCaso1 = false
            ))
        },
         customFormatter(date) {
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        }
    }
}
</script>

<style>
    .espacio {
        margin-left: 15px;
    }
    .messageTipoNotaCredito {
        color: #8d8d8d;
        font-size: 11px;
    }
    .input-requerido {
        color:red;
        opacity: 0.7;
    }
</style>


